import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import { Box } from '@material-ui/core';
import { ABOUT_ME_FIELD_NAMES } from '../../../constants/general';

const programNames = {
  scholarships: 'Scholarships',
  tradeLife: 'Community Supports',
  housing: 'Housing',
};

const getDisplayPrograms = (userPrograms) => {
  if (!userPrograms) return '';
  const programsToDisplay = Object.keys(userPrograms)
    .filter((key) => userPrograms[key])
    .map((key) => programNames[key]);
  if (programsToDisplay.length === 0) return '';
  if (programsToDisplay.length === 1) return `${programsToDisplay[0]}`;
  return `${programsToDisplay.slice(0, -1).join(', ')} and ${programsToDisplay[programsToDisplay.length - 1]}`;
};

const StudentAboutMe = ({ studentFirstName, studentLastName, programs, aboutMe, classes, version = 1 }) => {
  const paragraphs = [
    `Hi, my name is ${studentFirstName} ${studentLastName} and I am applying for ${getDisplayPrograms(
      programs
    )} with Successful Futures. Before you proceed with writing the recommendation, I’d like to share a few key details about myself that might be helpful.`,
    ...(version === 2 && aboutMe.post_graduation_plan_selection
      ? [`<p>${ABOUT_ME_FIELD_NAMES.postGraduationPlanSelection} ${aboutMe.post_graduation_plan_selection}. </p>`]
      : []),
    `<p><i>${ABOUT_ME_FIELD_NAMES.planText} </i> </p> ${aboutMe.post_graduation_plan}`,
    `<p><i>${ABOUT_ME_FIELD_NAMES.accomplishmentText} </i> </p> ${aboutMe.accomplishments}`,
    `<p><i>${ABOUT_ME_FIELD_NAMES.activityText} </i> </p> ${aboutMe.extracurricular_activities}`,
    'Thank you so much for writing a letter on my behalf.',
    `${studentFirstName} ${studentLastName}`,
  ];

  return (
    <Box className={classes.introContainer} style={{ marginBottom: '45px' }}>
      <Box mt="5px">
        <Divider style={{ height: '2px' }} />
        {paragraphs.map((text, index) => (
          <Box component="div" key={index} className={classes.intro} dangerouslySetInnerHTML={{ __html: text }} />
        ))}
      </Box>
    </Box>
  );
};

StudentAboutMe.propTypes = {
  studentFirstName: PropTypes.string.isRequired,
  studentLastName: PropTypes.string.isRequired,
  programs: PropTypes.shape({
    scholarships: PropTypes.bool,
    tradeLife: PropTypes.bool,
    housing: PropTypes.bool,
  }).isRequired,
  aboutMe: PropTypes.shape({
    post_graduation_plan: PropTypes.string.isRequired,
    accomplishments: PropTypes.string.isRequired,
    extracurricular_activities: PropTypes.string.isRequired,
  }).isRequired,
  classes: PropTypes.object,
  version: PropTypes.number.isRequired,
};

export default StudentAboutMe;
